import { mapActions } from 'vuex'
import Button from '@/components/helper/Button';
import Input from '@/components/helper/Input';
import {
    convertDateTime, timeFormat
} from '@/common/timeformat'

export default {
    data: () => ({
        portfolioUrl: process.env.VUE_APP_PORTFOLIO_URL,
    }),
    methods: {
        ...mapActions({
            setActiveTab: 'setActiveTab',
            setBreadCrumb: 'setBreadCrumb',
            showSnackbar: 'showSnackbar',
        }),
        getResponse(module){
            const status = this.$store.getters[`${module}/getStatus`]
            const msg = this.$store.getters[`${module}/getMessage`]
            return {status, msg}
        },
        convertDateTime(value){
            if(!value) return '-'
            return convertDateTime(value)
        },
        sessionFormat(session){
            if(!session) return '-'
            return `${session.name} (${timeFormat(session.beginTime)} - ${timeFormat(session.endTime)})`
        },
    },
    components: {
        Button,
        Input
    }
}